import type { AddressListResponse } from '../../types/member.js';
import { useTranslation } from 'react-i18next';

interface AddressTabProps {
  data: AddressListResponse;
}

/** @graph-connects none */
export function AddressTab({ data }: AddressTabProps) {
  const { t } = useTranslation();

  if (data.addresses.length === 0) {
    return (
      <div className="rounded-lg border border-[var(--color-border)] bg-[var(--color-bg-surface)] py-12 text-center text-sm text-[var(--color-text-muted)]">
        {t('member.noAddress')}
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-lg border border-[var(--color-border)] bg-[var(--color-bg-surface)]">
      <div className="border-b border-[var(--color-border)] px-4 py-3 text-[13px] font-semibold text-[var(--color-text-primary)]">
        {t('member.addressList')}
      </div>
      {data.addresses.map((addr, i) => (
        <div key={i} className="border-b border-[var(--color-border)] px-4 py-3 last:border-b-0">
          {addr.postalCode && (
            <div className="mb-0.5 text-[12px] text-[var(--color-text-secondary)]">
              〒{addr.postalCode}
            </div>
          )}
          <div className="text-[13px]">
            {[addr.prefecture, addr.city, addr.street].filter(Boolean).join(' ') || '-'}
          </div>
          {addr.building && (
            <div className="text-[13px] text-[var(--color-text-secondary)]">{addr.building}</div>
          )}
        </div>
      ))}
    </div>
  );
}
